module.exports = __webpack_public_path__ + "static/media/map.cf860fea.md";